import * as React from 'react';
import { Collapse } from 'antd';
import { TestProjectInputImpact } from '../types';

type Props = {
    inputs: TestProjectInputImpact[];
};

const TestProjectBaselineImpactList: React.FC<Props> = ({ inputs }) => (
    <Collapse>
        {inputs.map(input => (
            <Collapse.Panel
                key={input.topicId}
                header={`${input.name}: ${input.baselineCount} baseline${input.baselineCount === 1 ? '' : 's'}`}
            >
                {input.documents.length > 0 ? (
                    <ul>
                        {input.documents.map(document => (
                            <li key={document.packageId}>{document.name}</li>
                        ))}
                    </ul>
                ) : (
                    <span>No affected documents.</span>
                )}
            </Collapse.Panel>
        ))}
    </Collapse>
);

export default TestProjectBaselineImpactList;
